import { Tab } from "src/store/useUiuxStore";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useEffect, useMemo } from "react";

import { 
	getEQM2010_R01AllCount, 
	getEQM2010_R01DetailList, 
	getEQM2010_R01List,
	createEQM2010_R01,
	updateEQM2010_R01,
	deleteEQM2010_R01,
    getEQM2010_R01DetailListWithPlan,
    downloadExcel_EQM2010_R01
} from "./Api_EQM2010_R01";
import { showWarning, ShowSuccessFetch, showError, showSuccess } from "src/utils/toast/toastUtil";
import { EQM2010_R01Filter, useEQM2010_R01Store, defaultEQM2010_R01Filter } from "./Store_EQM2010_R01";
import { EQM2010_R01DetailDto, EQM2010_R01HeaderDto, defaultEQM2010_R01DetailDto } from "./Dto_EQM2010_R01";

import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { validateString } from "src/utils/string/stringUtil";
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	EQM2010_R01_DETAIL_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';

interface Props {
	gridRef: React.RefObject<AgGridReact<EQM2010_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<EQM2010_R01DetailDto> | null>;
	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;
	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
}

export const Content_EQM2010_R01 = (props: Props) => {
	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { moneyCdList, paycollectTargetList, yesNoList, inspectionStatusList } = useCommonCodeStore();
	
	const { 
		EQM2010_R01Filter, 
		EQM2010_R01PastFilter, 
		EQM2010_R01List, 
		setEQM2010_R01List, 
		setEQM2010_R01PastFilter, 
		setSelectedEQM2010_R01, 
		selectedEQM2010_R01,
		setAllCount,
		setEQM2010_R01DetailList,
		setDeletedEQM2010_R01DetailList,
		setSelectedEQM2010_R01DetailList,
		setOriginalEQM2010_R01DetailList,
		EQM2010_R01DetailList,
		insertEQM2010_R01DetailList,
		deletedEQM2010_R01DetailList,
		originalEQM2010_R01DetailList,
		selectedEQM2010_R01DetailList,
		addDeletedEQM2010_R01DetailList,
		removeDeletedEQM2010_R01DetailList,
		removeSelectedEQM2010_R01DetailList,
		initData,
		detailFetchTrigger, setDetailFetchTrigger,
		setScrollTop,
		setDetailScrollTop,
	} = useEQM2010_R01Store();


	useFetchActionbarAuth("EQM2010_R01");

	//  엑셀 다운로드 핸들러
	const handleExcelClick = useCallback(async () => {
		if (!selectedEQM2010_R01) {
			showError("설비를 선택해주세요.");
			return;
		}
		setLoadingSpinner(true);

		const params = {

			compCd: EQM2010_R01Filter.compCd || '',
			equipmentCd: selectedEQM2010_R01.equipmentCd || '',
			workplaceCd: EQM2010_R01Filter.workplaceCd || '',
			equipmentType: EQM2010_R01Filter.equipmentType || '',
			equipmentNm: EQM2010_R01Filter.equipmentNm || '',
			inspectType: EQM2010_R01Filter.inspectType || '',
			inspectCycle: EQM2010_R01Filter.inspectCycle || '',
		};

		const response = await downloadExcel_EQM2010_R01(
			'',
			params,
			EQM2010_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '점검계획 등록-excel.xlsx' });		
		setLoadingSpinner(false);
	}, [selectedEQM2010_R01, EQM2010_R01Filter, EQM2010_R01PastFilter, EQM2010_R01List, setLoadingSpinner]);

    const getParams = (filter: EQM2010_R01Filter) => {
		const params: any = {};
		if (filter.compCd) params.compCd = filter.compCd;
		if (filter.workplaceCd) params.workplaceCd = filter.workplaceCd;
		if (filter.equipmentType) params.equipmentType = filter.equipmentType;
		if (filter.equipmentCd) params.equipmentCd = filter.equipmentCd;
		return params;
	}

    const renewalAllCount = useCallback(async () => {
		const allCountResponse = await getEQM2010_R01AllCount(getParams(EQM2010_R01Filter));
		setAllCount(allCountResponse.data.data);
		return allCountResponse.data.data;
	}, [EQM2010_R01Filter, setAllCount]);


    const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);

		const responseData = (await getEQM2010_R01List(
			'search',
			getParams(EQM2010_R01Filter),
			EQM2010_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as EQM2010_R01HeaderDto[];
		setEQM2010_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedEQM2010_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedSAL2020_R01?.salBillNo)
			);
			setEQM2010_R01PastFilter(EQM2010_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedEQM2010_R01(undefined);
			setEQM2010_R01List([]);
			setEQM2010_R01DetailList([]); 
			setDeletedEQM2010_R01DetailList([]);
			setSelectedEQM2010_R01DetailList([]);
			setOriginalEQM2010_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [EQM2010_R01Filter, EQM2010_R01List, setEQM2010_R01List, setEQM2010_R01PastFilter, setSelectedEQM2010_R01, selectedEQM2010_R01, setScrollTop, setDetailScrollTop]);


	const defaultEQM2010_R01DetailRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(EQM2010_R01_DETAIL_ROW_VALIDATE, {
				inspectionStatusList,
				yesNoList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultEQM2010_R01DetailDto };
		}

		return {
			...defaultEQM2010_R01DetailDto,
			planYn: yesNoList[0].minorCd,
			inspectType: inspectionStatusList[0].minorCd,
			inserted: true,
		};
	}, [defaultEQM2010_R01DetailDto, inspectionStatusList, yesNoList, validateCommonCodeLists]);

	const initContainerData = useCallback(() => {
		initData();
	}, [initData]);

	const validateInsertData = (data: EQM2010_R01DetailDto[]) => {
		if (data.length === 0) {
			showWarning('점검계획을 입력해주세요.');
			return false;
		}
		return true;
	}

	// 저장 전 디테일 검증: 삭제표시 제외, 저장 대상의 필수값 점검
	const validateDetailForSave = useCallback((detailList: EQM2010_R01DetailDto[], deletedList: (string|number)[]) => {
		const deletedSet = new Set((deletedList || []).map(v => String(v)));
		const active = (detailList || []).filter(item => !deletedSet.has(String(item.valueIndex)) && item.planYn !== 'N');
		if (active.length === 0) {
			showWarning('저장할 점검계획이 없습니다.');
			return false;
		}
		// 필수값: inspectCd
		const missing = active.filter(d => !validateString((d as any).inspectCd));
		if (missing.length > 0) {
			showWarning('모든 점검계획의 점검코드가 필요합니다.');
			return false;
		}
		return true;
	}, []);

	// 삭제 전 검증: 선택된 삭제 항목 중 실제로 삭제 가능한 inspectCd가 하나 이상인지 확인
	const validateDetailForDelete = useCallback((detailList: EQM2010_R01DetailDto[], deletedList: (string|number)[]) => {
		if (!deletedList || deletedList.length === 0) {
			showWarning('삭제할 점검계획을 선택해주세요.');
			return false;
		}
		const resolvable = Array.from(new Set(
			deletedList
				.map((v) => {
					if (/^\d+$/.test(String(v))) {
						const found = detailList.find(d => d.valueIndex === Number(v));
						return (found as any)?.inspectCd?.trim();
					}
					return String(v).trim();
				})
				.filter((cd): cd is string => !!cd)
		));
		if (resolvable.length === 0) {
			showWarning('선택한 항목에서 삭제할 점검코드를 찾을 수 없습니다.');
			return false;
		}
		return true;
	}, []);

	//  수정: DetailTable의 점검계획 데이터를 기반으로 CRUD 처리
	const handleCreateClick = useCallback(async () => {
		if (!selectedEQM2010_R01) {
			showWarning('생성할 설비를 선택해주세요.');
			return;
		}

		if(!validateInsertData(EQM2010_R01DetailList)) return;

		try {
			setLoadingSpinner(true);
			//  서버 전송 전 equipmentCd 보정 주입
			const payloadList = EQM2010_R01DetailList.map(item => ({
				...item,
				equipmentCd: item.equipmentCd || selectedEQM2010_R01.equipmentCd
			}));
			//  DetailTable의 데이터를 그대로 전송
			const response = await createEQM2010_R01(payloadList);
			
			if (response.data.successFlag) {
				showSuccess('점검계획이 생성되었습니다.');
				// 생성 후 목록 새로고침
				await fetchData();
			} else {
				showError(response.data.message || '점검계획 생성에 실패했습니다.');
			}
		} catch (error: any) {
			console.error('점검계획 생성 오류:', error);
			showError(error.response?.data?.message || '점검계획 생성에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedEQM2010_R01, EQM2010_R01DetailList, setLoadingSpinner]);

	//  수정: DetailTable의 점검계획 데이터를 기반으로 수정 (삭제 포함)
	const handleSaveClick = useCallback(async () => {
		if (!selectedEQM2010_R01) {
			showWarning('수정할 설비를 선택해주세요.');
			return;
		}

		if (EQM2010_R01DetailList.length === 0) {
			showWarning('수정할 점검계획이 없습니다.');
			return;
		}

		// 저장 전 검증
		if (!validateDetailForSave(EQM2010_R01DetailList, deletedEQM2010_R01DetailList)) return;

		try {
			setLoadingSpinner(true);
			
			//  삭제된 항목이 있으면 먼저 삭제 처리 (inspectCd만 CSV로 생성)
			if (deletedEQM2010_R01DetailList.length > 0) {
				const toCsv = Array.from(new Set(
					deletedEQM2010_R01DetailList
						.map((v) => {
							// 숫자면 valueIndex로 간주하여 해당 행의 inspectCd 추출
							if (/^\d+$/.test(String(v))) {
								const found = EQM2010_R01DetailList.find(d => d.valueIndex === Number(v));
								return found?.inspectCd?.trim();
							}
							// 문자열이면 이미 inspectCd로 간주
							return String(v).trim();
						})
						.filter((cd): cd is string => !!cd)
				));
				if (toCsv.length === 0) {
					showWarning('삭제 대상에 유효한 점검코드가 없습니다.');
					return;
				}
				const inspectCdCsv = toCsv.join(',');
				const deleteResponse = await deleteEQM2010_R01(selectedEQM2010_R01.equipmentCd, inspectCdCsv);
				
				if (!deleteResponse.data.successFlag) {
					showError(deleteResponse.data.message || '점검계획 삭제에 실패했습니다.');
					return;
				}
			}
			
			//  삭제표시/planYn === 'N'은 PATCH 대상에서 제외하여 재삽입 방지
			const deletedSet = new Set(deletedEQM2010_R01DetailList.map(String));
			const toUpdateList = EQM2010_R01DetailList
				.filter(item => !deletedSet.has(String(item.valueIndex)) && item.planYn !== 'N')
				.map(item => ({
					...item,
					equipmentCd: item.equipmentCd || selectedEQM2010_R01.equipmentCd
				}));
			// PATCH는 대상이 있을 때만 호출
			const response = toUpdateList.length > 0
				? await updateEQM2010_R01(toUpdateList)
				: { data: { successFlag: true } } as any;
			
			if (response.data.successFlag) {
				showSuccess('점검계획이 저장되었습니다.');
				// 수정 후 목록 새로고침 및 삭제/선택 목록 초기화
				await fetchData();
				setDeletedEQM2010_R01DetailList([]);
				removeSelectedEQM2010_R01DetailList();
			} else {
				showError(response.data.message || '점검계획 수정에 실패했습니다.');
			}
		} catch (error: any) {
			console.error('점검계획 수정 오류:', error);
			showError(error.response?.data?.message || '점검계획 수정에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedEQM2010_R01, EQM2010_R01DetailList, deletedEQM2010_R01DetailList, setLoadingSpinner]);

	//  SAL6010_R01 방식: UI 삭제 핸들러 (삭제 표시/복구 토글)
	const handleDeleteClick = useCallback(() => {
		if (deletedEQM2010_R01DetailList.length > 0) {
			// 복구: 삭제 표시된 항목의 planYn을 'Y'로, isModified 반영 후 목록 정리
			const deletedSet = new Set(deletedEQM2010_R01DetailList.map(String));
			const newDetailList = EQM2010_R01DetailList.map(item => {
				if (deletedSet.has(String(item.valueIndex))) {
					const original = originalEQM2010_R01DetailList.find(o => o.valueIndex === item.valueIndex);
					const isModified = original ? original.planYn !== 'Y' : true;
					return { ...item, planYn: 'Y', isModified };
				}
				return item;
			});
			setEQM2010_R01DetailList(newDetailList);
			removeDeletedEQM2010_R01DetailList(deletedEQM2010_R01DetailList);
			removeSelectedEQM2010_R01DetailList();
		} else if (selectedEQM2010_R01DetailList.length > 0) {
			// 삭제 표시: 선택 항목의 planYn을 'N'으로, isModified: true로 표시
			const selectedSet = new Set(selectedEQM2010_R01DetailList.map(String));
			const newDetailList = EQM2010_R01DetailList.map(item => {
				if (selectedSet.has(String(item.valueIndex))) {
					return { ...item, planYn: 'N', isModified: true };
				}
				return item;
			});
			setEQM2010_R01DetailList(newDetailList);
			addDeletedEQM2010_R01DetailList(selectedEQM2010_R01DetailList);
			removeSelectedEQM2010_R01DetailList(selectedEQM2010_R01DetailList);
		} else {
			showWarning('삭제할 점검계획을 선택해주세요.');
		}
	}, [
		EQM2010_R01DetailList,
		originalEQM2010_R01DetailList,
		selectedEQM2010_R01DetailList,
		deletedEQM2010_R01DetailList,
		setEQM2010_R01DetailList,
		addDeletedEQM2010_R01DetailList,
		removeDeletedEQM2010_R01DetailList,
		removeSelectedEQM2010_R01DetailList,
	]);

	//  서버 삭제 핸들러 (별도 함수)
	const handleServerDeleteClick = useCallback(async () => {
		if (!selectedEQM2010_R01) {
			showWarning('삭제할 설비를 선택해주세요.');
			return;
		}

		if(!validateInsertData(EQM2010_R01DetailList)) return;

		if (!validateDetailForDelete(EQM2010_R01DetailList, deletedEQM2010_R01DetailList)) return;

		try {
			setLoadingSpinner(true);
			// 선택 리스트 기반 단건 삭제 호출
			for (const valueIndex of deletedEQM2010_R01DetailList) {
				const found = EQM2010_R01DetailList.find(d => d.valueIndex === Number(valueIndex));
				const inspectCd = found?.inspectCd?.trim();
				if (!inspectCd) continue;
				const response = await deleteEQM2010_R01(selectedEQM2010_R01.equipmentCd, inspectCd);
				if (!response.data.successFlag) {
					showError(response.data.message || `점검계획 삭제 실패 (${inspectCd})`);
					return;
				}
			}
			
			showSuccess('점검계획이 삭제되었습니다.');
			await fetchData();
		} catch (error: any) {
			console.error('점검계획 삭제 오류:', error);
			showError(error.response?.data?.message || '점검계획 삭제에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedEQM2010_R01, deletedEQM2010_R01DetailList, EQM2010_R01DetailList, setLoadingSpinner, fetchData]);
	
	
	const fetchDetailList = useCallback(async (equipmentCd: string) => {
		const responseData = (await getEQM2010_R01DetailListWithPlan(equipmentCd)).data.data;
		if(responseData && responseData.length > 0){
			setEQM2010_R01DetailList(responseData.map((value, idx) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
				equipmentCd: value.equipmentCd,
			})));
			setOriginalEQM2010_R01DetailList(responseData);
			setMessage(`${selectedEQM2010_R01?.equipmentNm}의 상세내역 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			showWarning('점검코드가 없습니다.');
			setEQM2010_R01DetailList([]);
		}
	}, [selectedEQM2010_R01, setEQM2010_R01DetailList, setOriginalEQM2010_R01DetailList, setMessage]);


    
	useEffect(() => {
		if (!detailFetchTrigger || !selectedEQM2010_R01?.equipmentCd) return;
		fetchDetailList(selectedEQM2010_R01.equipmentCd);
		setDetailFetchTrigger(false);
	}, [detailFetchTrigger, selectedEQM2010_R01, fetchDetailList, setDetailFetchTrigger]);

	return {
		handleExcelClick,
		fetchData,
		defaultEQM2010_R01DetailRow,
		initContainerData,
		handleCreateClick,
		handleSaveClick,
		handleDeleteClick,
		handleServerDeleteClick,
	};
}
